import WithdrawApprovalListPage from './WithdrawApprovalListPage';

export default WithdrawApprovalListPage;
